@if (!showChat()) {
  <div class="absolute bottom-5 left-5 z-50 flex gap-3">
    <button>
      <svg-icon
        src="icons/ai.svg"
        class="shadow-lg"
        (click)="showChat.set(true)"
      />
    </button>
    <button>
      <svg-icon
        [src]="showSimXpert() ? 'icons/xpert_on.svg' : 'icons/xpert_off.svg'"
        class="shadow-lg"
        (click)="showSimXpert.set(!showSimXpert())"
      />
    </button>
  </div>
}
